// $(function(){
$( document ).ready(function() {
  var isDesktopDevice = true;
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    isDesktopDevice = false;
    console.log('mobile device detected');
  } else {
    console.log('desktop device detected');
  }
  if (isDesktopDevice) {
    (function(){
      function createScene() {
        return function(p) {

          var explodingSystem;
          var img;
          var imgF;
          var initialParticleAmnt = 200;
          var offScreenMargin = 500;
          var allowRun = false;

          p.windowResized = function() {
            console.log('resize');
            p.resizeCanvas(p.max(1000, p.windowWidth), p.windowHeight);
          }

          p.setup = function() {
            // p.background(0);
            // console.log('width', p.windowWidth, 'height', p.windowHeight);
            var cwrapper = document.getElementById('top-section');
            p.createCanvas(cwrapper.offsetWidth, cwrapper.offsetHeight);
            img = p.loadImage('https://cdnus.melaleuca.com/Images/florify/ball-fuzzy.png');
            imgF = p.loadImage('https://cdnus.melaleuca.com/Images/florify/ball-fuzzy.png');

            explodingSystem = new ParticleSystem(p.createVector(p.width / 2, p.height / 2));
          }

          p.draw = function() {
            // p.background(0);
            p.clear();

            // explodingSystem.addParticle();
            explodingSystem.run();

          }

          var Particle = function(position) {
            this.hasExploded = false;
            this.reachedTarget = false;
            this.notCulled = true;
            this.velocity = p.createVector(p.random(-1,1), p.random(-1, 0));
            this.afterVelocity = p.createVector(p.random(-1,1), p.random(-1,1));
            this.position = position.copy();
            this.target = p.createVector(p.random(-offScreenMargin, p.width + offScreenMargin), p.random(-offScreenMargin, p.height + offScreenMargin));
            this.acceleration = p5.Vector.sub(this.target,this.positiontarget).normalize();
            this.radius = 0;
            this.maxRadius = p.random(.1, .75);
            this.initialDistanceToTarget = this.position.dist(this.target);
            this.img = Math.random() > .5 ? img : imgF;
            this.topSpeed = this.initialDistanceToTarget/15 + p.random(10);
            if (this.img === imgF){
              // fuzzy particles
              this.maxRadius = p.random(.3, .55);
              this.xTopSpeed = p.random(.3, 1);
            } else {
              // clear partciles
              this.maxRadius = p.random(.45, .65);
              this.xTopSpeed = p.random(1, 3);
            }
          };

          Particle.prototype.run = function() {
            this.update();
            this.display();
          };

          Particle.prototype.update = function() {
            //if (!this.hasExploded) {
            //  var deg = p.degrees(this.acceleration.heading())
            //  var extraAmount = getAdditionalSpeed(deg);
            //  this.acceleration.mult(extraAmount);
            //}
            var distanceToTarget = this.position.dist(this.target);
            if (!this.reachedTarget) {
              this.acceleration = p5.Vector.sub(this.target, this.position).normalize();
              this.acceleration.mult(this.position.dist(this.target));
              this.velocity.add(this.acceleration);
              this.velocity.limit(this.topSpeed);
              this.velocity.mult(p.map(distanceToTarget, this.initialDistanceToTarget + 20, 30, 1, 0.1));
              this.position.add(this.velocity);
            } else {
              this.position.add(this.afterVelocity);
            }
            // if (this.isDead()) {
            //   if (this.velocity.mag() > this.xTopSpeed) {
            //     this.velocity.limit(this.xTopSpeed);
            //   }
            // } else {
            //   if (this.velocity.mag() > this.topSpeed) {
            //     this.velocity.limit(this.topSpeed);
            //   }
            // }
            this.checkEdges();
            this.lifespan -= 2;
            this.lifespan = Math.max(0, this.lifespan);
            if (!this.reachedTarget) {
              this.radius = p.min(p.map(distanceToTarget, this.initialDistanceToTarget, 0, 0.001, this.maxRadius), this.maxRadius);
            }
            if (!this.reachedTarget && distanceToTarget < 30) {
              this.reachedTarget = true;
            }
          }

          function getAdditionalSpeed(d) {
            //console.log(d);
            var base = 1;
            var more = 1.15;
            if (d > -90 && d < 0) {
              //console.log('first', d);
              return p.map(d, -90, 0, base, more);
            } else if (d > -180 && d < -90) {
              //console.log('second', d);
              return p.map(d, -180, -90, more, base)
            } else if (d > 0 && d < 90){
              //console.log('third', d);
              return p.map(d, 0, 90, more, base);
            } else if (d > 90 && d < 180){
              //console.log('fourth', d);
              return p.map(d, 90, 180, base, more);
            }
          }

          Particle.prototype.checkEdges = function() {
            if (this.position.x > p.width + offScreenMargin) {
              this.hasExploded = true;
              this.position.x = 0 - offScreenMargin;
            }
            if (this.position.x < 0 - offScreenMargin) {
              this.hasExploded = true;
              this.position.x = p.width + offScreenMargin;
            }
            if (this.position.y > p.height + offScreenMargin) {
              this.hasExploded = true;
              this.position.y = 0 - offScreenMargin;
            }
            if (this.position.y < 0 - offScreenMargin) {
              this.hasExploded = true;
              this.position.y = p.height + offScreenMargin;
            }
          }


          Particle.prototype.display = function() {

            p.imageMode(p.CENTER);
            p.push();
            p.translate(this.position.x, this.position.y)
            p.scale(this.radius);
            if (this.hasExploded) {
              //p.tint(255, this.opacity);
            }
            p.image(this.img, 0, 0);
            p.pop();
          }

          var ParticleSystem = function(position) {
            this.origin = position.copy();
            this.particles = [];
            for (var i = 0; i < initialParticleAmnt; i++) {
              this.particles.push(new Particle(this.origin));
            }

            // fuzzy particles to the back
            this.particles.sort(function(a, b) {
              if (a.img === imgF){
                return 1;
              } else {
                return -1;
              }
            })
          }

          ParticleSystem.prototype.addParticle = function() {
            this.particles.push(new Particle(this.origin));
          }

          ParticleSystem.prototype.run = function() {
            for (var i = this.particles.length-1; i >= 0; i--) {
              var _p = this.particles[i];
              _p.run();

              // if not fuzzy remove after it is offscreen otherwise randomly remove
              if (_p.hasExploded && _p.notCulled && _p.img === img) {
                _p.notCulled = false;
                if (Math.random() > .1) {
                  this.particles.splice(i, 1);
                  // console.log('culled');
                }
              } else if (_p.hasExploded && _p.notCulled) {
                _p.notCulled = false;
                if (Math.random() > .3) {
                  this.particles.splice(i, 1);
                  // console.log('culled');
                }
              }
            }
          }

          document.addEventListener('remove', function(){
            p.remove();
          })

        }
      }

      window.start = function(){
        window.s = createScene();
        new p5(window.s, 'top-section');
      }

      var event = document.createEvent('Event');
      event.initEvent('remove', true, true);
      window.stop = function(){
        var c = document.getElementById('defaultCanvas0');
        c.remove();
        document.dispatchEvent(event);
      }

    }());
  }
  //*------------------------------------*\
  //      variables
  //*------------------------------------*/

  var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform),
    timingCapsule = 1000, // show the capsule and initial screen for this long
    timingStrains = 1500, // show 7 strains copy for this long
    timingCultures = 1500, // show 10 billion active cultures for this long
    timingPossibilities = 1000, // show possibilities copy for this long
    timingCircles = 800, // show circles and glow
    timingGlow = 200, // hide glow after this long
    centerTimer = 0; // center video player


  //*------------------------------------*\
  //      PAGE setup
  //*------------------------------------*/

  fixWidows();
  $('.js-lazyload').each(function() {
    $(this).attr('src',$(this).data('src'));
  });

  if (!isDesktopDevice) $('.section1').attr('style','background: url(https://cdnus.melaleuca.com/Images/florify/s1bg-mobile.jpg)');
  setTimeout(() => {
    $('.js-replay').trigger('click');
  }, 10);

  if (iOS) {
    $('.section').addClass('ios');
    if (screen.width < 1001) $('.section1').scrollLeft( 500 - screen.width/2 );
  } else {
    $('.section').addClass('notios');
    if (window.visualViewport.width < 1001) $('.section1').scrollLeft( 500 - window.visualViewport.width/2 );
  }
 
  //*------------------------------------*\
  //      listeners
  //*------------------------------------*/

  $('.js-testimonial').on('click', function(){
    var notClickedYet = true;
    if ($(this).hasClass('make-larger')) notClickedYet = false;
    $('.js-testimonial, .p--quote').removeClass('make-larger moveIn moveOut');
    if (notClickedYet) {
      $(this).addClass('make-larger');
      setTimeout(() => {
        var element = $(this).find('.p--quote');
        element.addClass('make-larger');
        element.css('width',$(this).find('.testimonial-img').width());
        // $(this).css('width',$(this).find('.testimonial-img').width());
        element.css('padding-left', $(this).find('.testimonial-img').width() * .2);
        element.css('padding-right', $(this).find('.testimonial-img').width() * .2);
      }, 210);
    }
  });

  $('.js-close').on('click', function(){
    $('.js-testimonial, .p--quote').removeClass('make-larger moveIn moveOut');
  });

  $('.js-closeplayer').on('click', function () {
      $('.videoScreen').removeClass('is-active');
      jwplayer('video1').remove();
  });

  $('.js-replay').on('click', function(){
    // stop()
    if (document.getElementById('defaultCanvas0')) stop();
    $(this).hide();
    setStage();
    setTimeout(anim1, timingCapsule, $(this));
  });

  // $(".js-pill").hover(
  //   function() {
  //     $(this).find('.tt-wrapper').addClass('is-active');
  //   }, function() {
  //     $('.section3 .is-active').removeClass('is-active');
  //   }
  // ).on('click', function(){
  //   if ($(this).find('.tt-wrapper').hasClass('is-active')) {
  //     $('.section3 .is-active').removeClass('is-active');
  //   } else {
  //     $(this).find('.tt-wrapper').addClass('is-active');
  //   }
  // });

  //  Carousel navigation
  var activeSlide = 1,
    allowClicks=true;
  var oldactiveSlide = 1;
  var $slides = $('.js-carousel').find('.js-carousel-copy');
  var totalNumSlides = $slides.length;

  // setup dots for nav
  $('.js-wm-nav-dots').html("");
  
  for (var i = totalNumSlides; i > 0; i--) {
    var template = '<div class="wm-dot js-dot js-dot-' + i + '" data-num="' + i + '"></div>';
    $('.js-wm-nav-dots').prepend(template);
  }

  setTimeout(() => {
    $('.js-dot-1').addClass('is-active');
  }, 100);

  $('.js-carousel-copy').css("left","-110%");
  $('.js-carousel-copy').eq(0).css("left","0");

  $('.js-carousel__nav--left').on('click', function(){
    triggerPill();
    oldactiveSlide = activeSlide;
    if (activeSlide===1) {activeSlide=totalNumSlides;} else {activeSlide--;}
    accarousel('left',activeSlide,oldactiveSlide);
  });

  $('.js-carousel__nav--right').on('click', function(){
    triggerPill();
    oldactiveSlide = activeSlide;
    if (activeSlide===totalNumSlides) {activeSlide=1;} else {activeSlide++;}
    accarousel('right',activeSlide,oldactiveSlide);
  });

  $('.js-dot').on('click', function(){
    oldactiveSlide = activeSlide;
    if (activeSlide < $(this).data('num')) {
      accarousel('right', $(this).data('num'),oldactiveSlide);
    } else if (activeSlide > $(this).data('num')) {
      accarousel('left', $(this).data('num'),oldactiveSlide);
    }
  });

  $(".js-tt-orange").hover(
    function() {
      $(this).addClass('is-active');
      $('.p--links').append('<div class="tt-orange ' + $(this).data('class') + '"><p class="p">' + $(this).data('copy') + '</p></div>');
    }, function() {
      $(this).removeClass('is-active');
      $('.tt-orange').remove();
    }
  );

  $('.js-tt-orange-mobile').on('click', function(){
    console.log($('.' + $(this).data('copy')));
    if ($('.' + $(this).data('copy'))[0].className.match('is-active') == null) {
      $('.js-copy1, .js-copy2').removeClass('is-active');
      $('.' + $(this).data('copy')).addClass('is-active');
    } else {
      $('.js-copy1, .js-copy2').removeClass('is-active');
    }
  });

  $('.js-flip').on('click', function(){
    if ($(this)[0].className.match('is-active') == null) {
      $('.js-flip').removeClass('is-active');
      $(this).addClass('is-active');
    } else {
      $('.js-flip').removeClass('is-active');
    }
  });

  //*------------------------------------*\
  //      Functions
  //*------------------------------------*/

  function triggerPill() {
    $('.img-wrapper').addClass('animate');
    setTimeout(() => {$('.animate').removeClass('animate');}, 300);
  }

  function accarousel(dir,slide,oldslide){
    if (allowClicks) {
      allowClicks = false;
      activeSlide = slide;
      if (dir==='left') {
        $slides.eq(oldslide-1).animate({left:"110%"});
        $slides.eq(slide-1).css("left","-110%");
      } else {
        $slides.eq(oldslide-1).animate({left:"-110%"});
        $slides.eq(slide-1).css("left","110%");
      }
      $slides.eq(slide-1).animate({left:"0"});
      $('.js-dot').removeClass('is-active');
      $('.js-dot-' + slide).addClass('is-active');
      setTimeout(function() {allowClicks=true;}, 400);
    }
  }

  // clear off everything from section1 and show first title
  function setStage() {
    $('.is-visible, .showing, .is-active, .moveIn, .moveOut, .is-scaled').removeClass('is-visible showing is-active hide-glow moveIn moveOut is-scaled');
    $('.is-active').removeClass('is-active moveIn moveOut');
    $('.js--h1-1').addClass('moveIn');
    setTimeout(() => {$('.js--h1-1, .pill-closeup').addClass('is-active');},10);
  }

  // hide h1-1 and show h1-2
  function anim1(element) {
    $('.js--h1-2').addClass('moveIn');
    $('.js--h1-1').addClass('moveOut');
    setTimeout(() => {$('.js--h1-2, .pill-closeup').addClass('is-active');},10);
    setTimeout(anim2, timingStrains, element);
  }

  // hide h1-2 and show h1-3
  function anim2(element) {
    $('.js--h1-3').addClass('moveIn');
    $('.js--h1-2').addClass('moveOut');
    setTimeout(() => {$('.js--h1-3, .pill-closeup').addClass('is-active');},10);
    setTimeout(anim3, timingCultures, element);
  }

  // hide h1-3 and show h1-4
  function anim3(element) {
    $('.h1 .span').removeClass('moveIn is-active moveOut');
    $('.js--h1-4').addClass('is-active');
    element.show();
    // setTimeout(start, timinganimation);
    setTimeout(anim3a, timingPossibilities);
  }

  // remove huge pill and show little pills and begin animation explosion
  function anim3a() {
    $('.js--h1-4').addClass('is-scaled');
    if (isDesktopDevice) {start();}
    $('.pill-closeup').removeClass('is-active');
    $('.testimonial').addClass('is-visible');
    setTimeout(anim4, timingCircles);
  }

  // show pictures over testimonial bubbles
  function anim4() {
    $('.testimonial').addClass('showing');
    setTimeout(anim5, timingGlow);
  }

  // remove glow from testimonials
  function anim5() {
    $('.testimonial').addClass('hide-glow');
    $('.top-section').addClass('is-active');
  }

  function fixWidows() {
    $('h1,h2,h3,li,p').each(function() {
      $(this).html($(this).html().replace(/\s([^\s<]+)\s*$/,'&nbsp;$1'));
    });
  }

  $('.js-play-video').on('click', function () {
    centerTimer = 0;
    $('.videoScreen').addClass('is-active');
    var mediaid = $(this).data('mediaid');
    var imagepath = $(this).data('image');
    jwplayer('video1').setup({
        'mediaid': mediaid,
        'image': imagepath,
        'autostart': true,
        'sources': [{
          'file': 'https://video-us.melaleuca.com/ProductStore/florify_seo_video_enUS/hls/hls_florify_seo_video_enUS.m3u8'
        }, {
          'file': 'https://content.jwplatform.com/videos/' + mediaid + '-G7g7vhiJ.mp4'
        }, {
          'file': 'https://content.jwplatform.com/videos/' + mediaid + '.webm'
        }],
        'customProps': mediaid
    });
    setTimeout(function () {
        placeInCenter('videoIDwrapper');
    }, 100);
  });

  function placeInCenter(idName) {
      centerTimer++;
      var viewportheight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
          elementheight = $('#' + idName).height(),
          scrollPosition = window.pageYOffset,
          videoTopPos = Math.round((viewportheight - elementheight) / 2 + scrollPosition);
      if (elementheight == 0) {
          setTimeout(function () {
              if (centerTimer < 50) placeInCenter(idName);
          }, 100);
      } else {
          if (videoTopPos < scrollPosition) videoTopPos = scrollPosition;
          $('#' + idName).css("top", videoTopPos + 'px').fadeIn();
          // position close button
          $('.xcloseplayer').css('top', videoTopPos + 10 + 'px');

          if ($('#' + idName).css('top') == videoTopPos + "px") {
              $('#' + idName).addClass('is-active');
          } else {
              setTimeout(function () {
                  if (centerTimer < 50) placeInCenter(idName);
              }, 100);
          }
      }
  }

});








// for (let index = 0; index < 10; index++) {

//   $('.anim' + index).removeClass('anim' + index);
  
// }